import { IconListSearch, IconPaperclip, IconTools } from '@tabler/icons-solidjs'
import { For, Show } from 'solid-js'
import { session } from '../../lib/session.ts'
import { assistantQuickActions } from '../../modules/ai-starters.ts'
import { MenuRow, PopoverPanel, usePopover } from './primitives.tsx'

export const ASSISTANT_UNAVAILABLE_REPLY =
  'Помічник ще не під’єднано. Адміністратор має додати ключ OpenAI та надати доступ до моделей. Дані CRM не змінено.'

export const TOOLS = () => {
  const actor = session()?.actor
  return actor ? assistantQuickActions(actor) : []
}
export const SUGGESTIONS = () => TOOLS().slice(0, 3)

export const AssistantTools = (props: {
  onChoose: (text: string) => void
  onAttach?: () => void
  disabled?: boolean
}) => {
  const tools = usePopover()
  return (
    <div class="relative" ref={tools.ref}>
      <button
        type="button"
        disabled={props.disabled}
        aria-label="Інструменти"
        title="Інструменти"
        aria-expanded={tools.open()}
        onClick={() => tools.setOpen(!tools.open())}
        class="grid size-8 place-items-center rounded-[0.5rem] text-text-muted transition-transform duration-(--duration-press) active:scale-[0.97] hover:bg-surface-sunken hover:text-text focus-visible:outline-2 focus-visible:outline-accent disabled:pointer-events-none disabled:opacity-45 max-md:size-(--size-touch)"
      >
        <IconTools class="size-4" stroke-width={1.5} aria-hidden="true" />
      </button>
      <Show when={tools.open()}>
        <PopoverPanel class="bottom-full left-0 mb-1.5 w-64 origin-bottom-left">
          <p class="px-2 pt-1 pb-1 text-caption text-text-subtle">Інструменти</p>
          <For each={TOOLS()}>
            {(tool) => (
              <MenuRow
                icon={<IconListSearch stroke-width={1.5} />}
                onClick={() => {
                  props.onChoose(tool.prompt)
                  tools.setOpen(false)
                }}
              >
                {tool.title}
              </MenuRow>
            )}
          </For>
          <Show when={props.onAttach}>
            <div class="my-1 border-t border-border" />
            <MenuRow
              icon={<IconPaperclip stroke-width={1.5} />}
              onClick={() => {
                props.onAttach?.()
                tools.setOpen(false)
              }}
            >
              Додати файл
            </MenuRow>
          </Show>
        </PopoverPanel>
      </Show>
    </div>
  )
}
